import { faRedoAlt } from '@fortawesome/fontawesome-free-solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useEffect, useState } from 'react';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';

import { ImageBlock } from '../../components/basic/image';
import { Block, Flex } from '../../components/basic/layout';
import { P } from '../../components/basic/text';
import { Blue, BorderColor } from '../../constants/colors';

export const ProductImages = ({ state, navigationData, startOverHandler }) => {
	const mobile = state.resize < 1025;
	const [elementRef, setElementRef] = useState(null);

	const [imgUrl, setImgUrl] = useState('');
	const [thumbClick, setThumbClick] = useState(false);
	const [imageData, setImageData] = useState({});

	const imageDescriptionName = `${imageData?.product?.displayName} image`;

	const thumbClickHandler = (link) => {
		setThumbClick(true);
		setImgUrl(link);
	};

	useEffect(() => {
		if (state.step === 'Review' && !thumbClick) {
			setImgUrl(imageData?.product?.imageUrl);
		} else if (!thumbClick) {
			const img = state?.choices[state.substep]?.product?.imageUrl;
			const noImg = state?.choices[state.substep]?.product?.noImage;
			setImgUrl(img ? img : noImg);
		}
	}, [state.substep, JSON.stringify(state.choices), imageData]);

	useEffect(() => {
		if (navigationData?.length)
			navigationData?.forEach((stepData) => {
				if (stepData?.title === 'Size & Material') {
					setImageData(stepData);
				}
			});
	}, [navigationData]);

	useEffect(() => {
		setElementRef(document.getElementsByClassName('iiz')[0]);
    }, [elementRef]);

	return (
		<Block width={mobile ? '100%' : '55%'}>
			<Flex align='center'>
				{!mobile && (
					<Block width='10rem' textAlign='center'>
						<Block
							cursor='pointer'
							onClick={() => startOverHandler()}
							margin='0 0 30px 0'>
							<P size='32px' color={Blue} margin='0 0 10px 0'>
								<FontAwesomeIcon icon={faRedoAlt} />
							</P>
							<P weight='bold' size='12px'>
								Start Over
							</P>
						</Block>
					</Block>
				)}
				<Block>
					{state.step !== 'Review' ? (
						<Fragment>
							{(!mobile ||
								(mobile && state.choices[state.substep]?.required)) && (
								<Block border='1px solid' borderColor={BorderColor}>
									{((imageData &&
										imageData?.product &&
										imageData?.product?.imageSet?.length > 0 &&
										imageData?.product?.imageSet[
											imageData?.product?.imageSet?.length - 1
										]?.variants?.product_lg) ||
										imageData?.product?.noImage) && (
										<ImageBlock
											key={`ChosenProductImage`}
											figureHeight='auto'
											figureWidth='100%'
											width='100%'
											height='auto'
											alt={imageDescriptionName}
											ariaLabel={imageDescriptionName}
											src={
												thumbClick
													? imgUrl
													: state &&
													  state.choices &&
													  state.choices[state.substep]?.step ===
															'Front'
													? imageData?.product?.imageUrl
													: imageData?.product?.imageSet?.length &&
													  imageData?.product?.imageSet[
															imageData?.product?.imageSet?.length - 1
													  ]?.variants?.product_lg
											}
										/>
									)}
								</Block>
							)}
							{imageData?.product?.imageSet?.length > 0 && (
								<Flex>
									{imageData.product.imageSet.map((image, key) => (
										<ImageBlock
											figureHeight='auto'
											key={`Image_set-Image-${key}`}
											figureWidth='100%'
											width='100%'
											height='auto'
											src={image?.variants?.product_lg}
											click={() => thumbClickHandler(image?.variants?.product_lg)}
											cursor='pointer'
											alt={imageDescriptionName}
											ariaLabel={imageDescriptionName}
										/>
									))}
								</Flex>
							)}
						</Fragment>
					) : (
						((imageData &&
							imageData?.product &&
							imageData?.product?.imageSet?.length > 0 &&
							imageData?.product?.imageSet[
								imageData?.product?.imageSet?.length - 1
							]?.variants?.product_lg) ||
							imageData?.product?.noImage) && (
								<ImageBlock
									key={`ChosenProductImage-0`}
									figureHeight='auto'
									figureWidth='100%'
									width='100%'
									height='auto'
									alt={imageDescriptionName}
									ariaLabel={imageDescriptionName}
									src={
										thumbClick
											? imgUrl
											: imageData?.product?.imageSet[
												imageData?.product?.imageSet?.length - 1
											]?.variants?.product_lg
									}
								/>
						)
					)}
				</Block>
			</Flex>
			{state.step === 'Review' && !mobile && (
				<Flex justify='space-evenly'>
					{imageData?.product?.imageSet?.length > 0 &&
						imageData.product.imageSet.map((image, key) => (
							<ImageBlock
								figureHeight='auto'
								key={`Image_set-Image-${key}`}
								figureWidth='100%'
								width='100%'
								height='auto'
								click={() => thumbClickHandler(image?.variants?.product_lg)}
								src={image?.variants?.product_lg}
								cursor='pointer'
								alt={imageDescriptionName}
								ariaLabel={imageDescriptionName}
							/>
						))}
				</Flex>
			)}
		</Block>
	);
};
